<template>
  <div>
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/icon-words.svg" width="50" alt="Minds">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
        <h2 class="animation-top animation-delay-02">BANK <span>OF WORDS</span></h2>
        <hr class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Aqui você encontra as palavras conquistadas durantes os exercícios das unidades. Enjoy!</p>
      </div>
    </div>
    <div class="box-content shadow-box box-content-border min-height" style="position: relative;">
      <div class="search-words">
        <div style="background: #dfdfdf;" class=" input-space container align-items-center">
          <input type="text" placeholder="Pesquise por alguma palavra" class="input" v-model="filter">
        </div>
      </div>
      <palavras :data="words" />
      <div class="pagination-words">
        <div class="pagination-words__content" v-if="words.length > 12">
          <div class="pagination-words__content__item" @click="prevPage()" :class="{ disabled: page == 1 }">
            <font-awesome-icon icon="arrow-left"/>
          </div>
          <div class="pagination-words__content__item" v-for="p in pages" :key="`page-${p}`" :class="{ current: p == page }" @click="selectPage(p)">
            {{ p }}
          </div>
          <div class="pagination-words__content__item" @click="nextPage()" :class="{ disabled: page == pages }">
            <font-awesome-icon icon="arrow-right"/>
          </div>
        </div>
      </div>
      <modal :show="showModal">
        <div v-if="checkObject(word)">
          <div class="modal-content">
            <h5 class="word-upper">{{ word._id }}</h5>
            <b>Phonetic: {{ word.pronunciation.phoneticSpelling }}</b>
            <div class="margin-left-10" v-for="lex in word.lexicalEntries">
              <div class="">
                <p> <b>Category: </b> <span> {{ lex.lexicalCategory }} </span> </p>
              </div>
              <div class="margin-left-10">
                <ul class="margin-left-10" v-for="ent in lex.entries">
                  <li>
                    <p v-for="gf in ent.grammaticalFeatures"><b> {{ gf.type }}: </b> <span> {{ gf.text }} </span> </p>
                    <!-- <p><b> Gramatical Features: </b> <span> {{ gf.type }} {{ gf.text }} </span> </p> -->
                  </li>
                  <li v-if="ent.senses && ent.senses.length > 0" class="margin-left-10" v-for="sen in ent.senses">
                    <p class="word-capitalized"> {{ sen.translation }}</p>
                    <ul class="margin-left-10">
                      <li v-if="sen.notes && sen.notes.length > 0">
                        <!-- <p>Notes:</p>
                        <ul> -->
                        <!-- <li class="margin-left-10" v-for="note in sen.notes"> -->
                        <!-- <li class="margin-left-10"> -->
                        <!-- <p>Word: {{ sen.notes[0].text }}</p> -->
                        <p class="word-capitalized"> Word: {{ sen.notes[0].text }}</p>
                        <p class="word-capitalized">Type: {{ splitWord(sen.notes[0].type) }}</p>
                        <!-- </li> -->
                        <!-- </ul> -->
                      </li>
                      <li v-if="sen.examples && sen.examples.length > 0">
                        <!-- <p>Examples:</p>
                        <ul> -->
                          <!-- <li class="margin-left-10" v-for="ex in sen.examples"> -->
                          <!-- <li class="margin-left-10"> -->
                            <p>Phrase: {{ firstUpper(sen.examples[0].text) }}</p>
                            <p>Translation: {{ firstUpper(sen.examples[0].translation) }}</p>
                          <!-- </li>
                        </ul> -->
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { cloneDeep } from 'lodash'
  import palavras from '@/components/words'
  import modal from '@/components/modal'
  import wordBus from '@/components/words/wordBus'
  import modalBus from '@/components/modal/modalBus'

  export default {
    components: {
      palavras,
      modal
    },
    data () {
      return {
        showModal: false,
        word: {},
        filter: '',
        limit: 12,
        page: 1
      }
    },
    computed: {
      _words_ () {
        const books = this.$store.getters['student/GET'].books
        const words = cloneDeep(this.$store.getters['word/getWords'])
          .filter(w => {
            if (!books) {
              if (!w.book) return true
              else return false
            }
            if (w.book && w.unit) {
              if (!books[w.book]) return false
              const units = books[w.book].units
              if (!units[w.unit]) return false
              const topics = units[w.unit].topics
              if (!topics[w.topic].finished) return false
            }
            return true
          })
          .map((w, index) => {
            if (w.book) {
              const book = books[w.book].title,
                    unit = books[w.book].units[w.unit].number,
                    topic = books[w.book].units[w.unit].topics[w.topic].title

              w.book = book
              w.unit = unit
              w.topic = topic
            }
            w.index = index + 1
            return w
          })
          .filter(w => {
            if (!w.book) return w.key.toLowerCase().includes(this.filter.toLowerCase())
            return w.key.toLowerCase().includes(this.filter.toLowerCase()) ||
                   w.book.toLowerCase().includes(this.filter.toLowerCase()) ||
                   w.unit.toString().includes(this.filter.toLowerCase()) ||
                   w.topic.toLowerCase().includes(this.filter.toLowerCase())
          })
        return words
      },
      words () {
        const copy = cloneDeep(this._words_)

        let start = (this.limit * this.page) - this.limit,
            end = start + this.limit

        if ((copy.length - start) < this.limit) {
          end = copy.length
        }

        return copy.slice(start, end)
      },
      pages () {
        const division = this._words_.length / this.limit
        const str = division.toString()
        if (!str.includes('.')) return division
        return parseInt(str.split('.').shift()) + 1
      }
    },
    methods: {
      close () {
        this.showModal = false
      },
      setWord (word) {
        this.word = word
        this.showModal = true
      },
      checkObject (obj) {
        return Object.keys(obj).length > 0
      },
      splitWord (word) {
        const arr = word.split(/(?=[A-Z])/)
        return arr.join(' ').toLowerCase()
      },
      firstUpper (phrase) {
        return phrase.charAt(0).toUpperCase() + phrase.slice(1)
      },
      selectPage (page) {
        if (page !== this.page) this.page = page
      },
      nextPage () {
        if (this.page < this.pages ) this.page++
      },
      prevPage () {
        if (this.page > 1 ) this.page--
      }
    },
    watch: {
      pages () {
        this.page = 1
      }
    },
    mounted () {
      modalBus.$on('close', this.close)
      wordBus.$on('setWord', this.setWord)
    },
    beforeDestroy () {
      modalBus.$off('close', this.close)
      wordBus.$off('setWord', this.setWord)
    }
  }
</script>

<style media="screen" lang="scss">
  .search-words {
    padding: 10px;
    box-sizing: border-box;
    .el-input {
      .el-input__inner {
        &.el-input__inner--white {
          height: 50px
        }
        height: 40px;
        border-radius: 20px;
      }
    }
  }

  .pagination-words {
    width: 100%;
    &__content {
      display: flex;
      justify-content: center;
      align-items: center;
      &__item {
        cursor: pointer;
        margin: 2.5px;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 25px;
        background-color: #E3E3E3;
        &:hover {
          background-color: #D3D3D3;
        }
        &.current {
          background-color: #D3D3D3;
        }
        &.disabled {
          cursor: not-allowed;
          color: #BBB;
        }
      }
    }
  }

  .modal-content {
    text-overflow: clip;
    ul li {
      margin-bottom: 5px;
    }
  }

  .word-upper {
    text-transform: uppercase;
  }

  .word-underlined {
    text-decoration: underline;
  }

  .word-capitalized {
    text-transform: capitalize;
  }
  

</style>



// WEBPACK FOOTER //
// src/pages/words/index.vue